import React from 'react';
import { createSubstyle, PropsDecoratorProvider } from 'substyle';
import { decorateAsDataAttributes, decorateAsClasses } from './propsDecorators';
export var asDataAttributes = function asDataAttributes(style) {
  return createSubstyle({
    style: style
  }, decorateAsDataAttributes);
};
export var asDataClasses = function asDataClasses(style) {
  return createSubstyle({
    style: style
  }, decorateAsClasses);
};
export var StylesAsDataAttributes = function StylesAsDataAttributes(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(PropsDecoratorProvider, {
    value: decorateAsDataAttributes
  }, children);
};
export var StylesAsClasses = function StylesAsClasses(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement(PropsDecoratorProvider, {
    value: decorateAsClasses
  }, children);
};